export function isBodyEmpty(value?: string) {
  return !value || value === '<p><br></p>';
}
